import { useEffect, useMemo, useState } from "react";
import { format, parseJSON } from "date-fns";
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import LeaveRequestService from "../Services/LeaveRequestService";
import LeaveForbiddenWeekModel from "../Models/LeaveForbiddenWeekModel";
import LeaveForbiddenWeekModal from "../Components/LeaveForbiddenWeekModal";

const LeaveForbiddenWeeks = () => {
  const { instance } = useMsal();

  const leaveRequesService = useMemo(
    () => new LeaveRequestService(instance),
    [instance]
  );

  const [forbiddenWeeks, setForbiddenWeeks] = useState<
    LeaveForbiddenWeekModel[]
  >([]);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedForbiddenWeek, setSelectedForbiddenWeek] =
    useState<LeaveForbiddenWeekModel | null>(null);

  useEffect(() => {
    async function loadData() {
      try {
        const data = await leaveRequesService.getAllForbiddenWeeks();

        setForbiddenWeeks(data);
      } catch (err) {
        toast.error("Fout bij het ophalen van de data.");
      }
    }

    loadData();
  }, [leaveRequesService]);

  async function afterSave() {
    try {
      setShowModal(false);

      const data = await leaveRequesService.getAllForbiddenWeeks();

      setForbiddenWeeks(data);
    } catch (err) {
      toast.error("Fout bij het ophalen van de data.");
    }
  }

  function afterClose() {
    setShowModal(false);
  }

  let modal = null;
  if (showModal) {
    modal = (
      <LeaveForbiddenWeekModal
        forbiddenWeek={selectedForbiddenWeek}
        afterSave={() => afterSave()}
        afterCancel={() => afterClose()}
      />
    );
  }

  return (
    <div className="container-fluid">
      <table className="table table-sm text-nowrap">
        <thead>
          <tr>
            <th>Van</th>
            <th>Tot en met</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {forbiddenWeeks.map((record) => {
            return (
              <tr key={record.id}>
                <td>{format(parseJSON(record.start), "dd/MM/yyyy")}</td>
                <td>{format(parseJSON(record.end), "dd/MM/yyyy")}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    title="Aanpassen"
                    onClick={() => {
                      setShowModal(true);
                      setSelectedForbiddenWeek(record);
                    }}
                  >
                    <i className="fas fa-pen"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="row m-4">&nbsp;</div>
      <div
        className="container-fluid fixed-bottom pb-2 pt-2"
        style={{ backgroundColor: "white" }}
      >
        <button
          className="btn btn-primary"
          type="button"
          onClick={() => {
            setShowModal(true);
            setSelectedForbiddenWeek(null);
          }}
        >
          Toevoegen
        </button>
      </div>
      {modal}
    </div>
  );
};

export default LeaveForbiddenWeeks;
